module.exports = __webpack_public_path__ + "components/flag/static/square/ph-4637f7da0e3c67a5d78f9fd5749e5f59.svg";